import React from "react";
import { NavLink } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";

const Sidebar = () => {
    const theme = useTheme();
    
    const baseLinkClasses =
        "d-block px-3 py-2 rounded fw-semibold text-light text-decoration-none";
    
    const activeLinkClasses =
        "bg-white text-dark fw-bold";
    
    return (
        <nav
            className="d-flex flex-column"
            style={{
                width: 220,
                height: "100vh",
                padding: 20,
                backgroundColor: theme.colors.sidebarBg,
                color: theme.colors.textLight,
                boxSizing: "border-box",
            }}
        >
            <h2
                className="mb-4"
                style={{ fontSize: "1.8rem", fontWeight: 700 }}
            >
                HasibX
            </h2>
            
            <ul
                className="nav flex-column flex-grow-1"
                style={{ listStyle: "none", padding: 0, margin: 0, gap: "1rem", display: "flex", flexDirection: "column" }}
            >
                {[
                    { to: "/", label: "Dashboard" },
                    { to: "/posts", label: "Posts" },
                    // { to: "/posts/create", label: "Create Post" },
                    { to: "/portfolio", label: "Portfolio" },
                    { to: "/projects", label: "Projects" },
                    // { to: "/projects/create", label: "Create Project" },
                    // { to: "/projects/edit/:projectId", label: "Edit Project" },
                    { to: "/tags", label: "Tags" },
                    { to: "/categories", label: "Categories" },
                    { to: "/profile", label: "Profile" },
                    { to: "/social-links", label: "Social Links" },
                ].map(({ to, label }) => (
                    <li key={to}>
                        <NavLink
                            to={to}
                            className={({ isActive }) =>
                                isActive
                                    ? `${baseLinkClasses} ${activeLinkClasses}`
                                    : baseLinkClasses
                            }
                            style={{
                                transition: "background-color 0.2s ease",
                            }}
                            onFocus={(e) => {
                                e.target.style.backgroundColor = "#fff";
                                e.target.style.color = "#000";
                            }}
                            onBlur={(e) => {
                                if (!e.target.classList.contains("active")) {
                                    e.target.style.backgroundColor = "transparent";
                                    e.target.style.color = theme.colors.textLight;
                                }
                            }}
                        >
                            {label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Sidebar;
